import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../Elements/Spinner';
import { Icon } from '@haldor/ui';
import './Search.scss';

var Search = /*#__PURE__*/function (_Component) {
  _inherits(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.autofocus == true) {
        if (_this.refs['input'] != null) {
          _this.refs['input'].focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isValid", function () {
      if (_this.state.value.length > 0) {
        if (_this.state.value.trim().length == 0) {
          return false;
        }
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "throttle", function (func, immediate) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var later = function later() {
          this.timeout = null;
          if (!immediate) func.apply(this, args);
        };

        var callNow = immediate && !_this.timeout;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(later, _this.autoSearchLimit);
        if (callNow) func.apply(_assertThisInitialized(_this), args);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function () {
      var _this$props = _this.props,
          input = _this$props.input,
          onSubmit = _this$props.onSubmit;

      var value = _this.getValue();

      if (!_this.props.allowEmpty && value.query == '') {
        // Dont submit empty strings
        return false;
      }

      if (_this.props.lengthLimit != null) {
        if (value.query.length < _this.props.lengthLimit) {
          return false;
        }
      }

      if (input != null && input.onSubmit != null) {
        input.onSubmit(value);
      }

      if (onSubmit != null) {
        onSubmit(value);
      }

      if (_this.props.clearOnSubmit) {
        _this.setState({
          value: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function () {
      var type = 'search';
      var query = _this.state.value;
      var modifier = null;

      if (_this.state.value.charAt(0) == '@') {
        type = 'picker';
        modifier = '@';
        query = _this.state.value.substr(1);
      }

      if (_this.state.value.charAt(0) == '#') {
        type = 'picker';
        modifier = '#';
        query = _this.state.value.substr(1);
      }

      if (_this.state.value.charAt(0) == '!') {
        type = 'picker';
        modifier = '!';
        query = _this.state.value.substr(1);
      }

      return {
        type: type,
        modifier: modifier,
        query: query
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onValueChange", function (event) {
      var _this$props2 = _this.props,
          input = _this$props2.input,
          onChange = _this$props2.onChange;

      if (_this.props.onChange) {
        _this.props.onChange(event.target.value);
      }

      _this.setState({
        value: event.target.value
      }, function () {
        if (!_this.isValid()) {
          return;
        }

        if (_this.getValue().type == 'picker') {
          var onSubmit = _this.throttle(_this.onSubmit);

          onSubmit();
          return;
        }

        if (_this.props.autoSearch) {
          var _onSubmit = _this.throttle(_this.onSubmit);

          _onSubmit();

          return;
        }
      });

      if (input != null && input.onChange != null) {
        input.onChange(event.target.value);
      }

      if (onChange != null) {
        onChange(event.target.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.keyCode == 13) {
        event.preventDefault();

        _this.onSubmit(_this.state.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onIconClick", function () {
      _this.refs['input'].focus();
    });

    var _value = '';

    if (props.input != null && props.input.value != null) {
      _value = props.input.value;
    }

    _this.state = {
      value: _value
    };
    _this.timeout = null;
    _this.autoSearchLimit = 200;
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "search-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-box-container",
        onClick: this.onIconClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "search-box-icon"
      }, this.props.loading ? /*#__PURE__*/React.createElement(Spinner, {
        small: true
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "Magnify"
      })), /*#__PURE__*/React.createElement("input", {
        type: "search",
        value: this.state.value,
        onChange: this.onValueChange,
        onKeyDown: this.onKeyDown,
        ref: "input",
        placeholder: this.props.placeholder
      })), /*#__PURE__*/React.createElement("div", {
        className: "search-children"
      }, this.props.children));
    }
  }]);

  return Search;
}(Component);

Search.defaultProps = {
  autoSearch: false,
  allowEmpty: false,
  clearOnSubmit: false,
  lengthLimit: null
};
Search.propTypes = {
  autoSearch: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  clearOnSubmit: PropTypes.bool,
  lengthLimit: PropTypes.number
};
export default Search;